// @flow

import React, { useState } from 'react';
import { log } from '../../utils/jsUtils';
import { useStore } from '../../store';

import AppBar from '@mui/material/AppBar';
import Typography from '@mui/material/Typography';
import Toolbar from '@mui/material/Toolbar';
import Grid from '@mui/material/Grid';
import Tooltip from '@mui/material/Tooltip';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';

import AddPropertyIcon from '@mui/icons-material/AddLocation';
import AddUnitIcon from '@mui/icons-material/AddLocation';
import AddTenantIcon from '@mui/icons-material/GroupAdd';
import AddStaffIcon from '@mui/icons-material/GroupAdd';

import AddUnit from './AddUnitDialog';
import HeaderTopBar from '../HeaderTopBar';
import SPBackend from '../../services/SPBackend';

import memberHeaderStyles from '../Feed/Styles/MemberHeader.Style';

import type { Building, Unit } from '../../services/SPBackend';

type Props = {
  mobileOpen: bool,
  property: Building,
  usehandleDrawerToggle: Function,
  setUnitsAndTenants: Function
};

const PropertyHeader = (props: Props) => {
  log('[PropertyHeader] props: ', props);
  const {
    property,
    setUnitsAndTenants
  } = props;
  const theme = useTheme();
  const [openAddUnitDialog, setOpenAddUnitDialog] = useState(false);

  const [store, dispatch] = useStore();
  const {
    user,
    accountSettings,
    i18n
  } = store;

  const handleAddUnit = (unit: Unit) => {
    const { Floor, Apt } = unit;
    log('[handleAddUnit] unit: ', unit);
    const newUnit = {
      Floor,
      Apt,
      PropertyKey: property.PropertyKey
    };
    SPBackend.createUnit(newUnit, user)
      .then((response) => {
        const {data: newUnit} = response;
        log('[createUnit] res: ', newUnit);
        dispatch({
          type: 'ACTION_SET_ACCOUNT_SETTINGS',
          accountSettings: {
            ...accountSettings,
            SetupRequired: {
              ...accountSettings.SetupRequired,
              Units: false
            }
          }
        });
        setUnitsAndTenants(prevState => {
          return [
            {
              unit: newUnit,
              tenants: []
            },
            ...prevState
          ];
        });
      })
      .catch(error => {
        dispatch({
          type: 'ACTION_SET_SNACK_MSG', 
          snackMessage: {
            message: error.response ? error.response.data : 'An error occured. Please try again',
            level: 'error',
            duration: 3000
          }
        });
        log('[handleAddUnit.createUnit] error: ', error);
      });
  };

  return (
    <AppBar
      sx={memberHeaderStyles.appBar(theme)}
      position="fixed"
    >
      <Toolbar
        sx={memberHeaderStyles.toolbar(theme)}
        disableGutters
      >
        <Grid
          container
          direction='column'
        >
          <HeaderTopBar>
            <Typography
              sx={memberHeaderStyles.pageTitle(theme)}
              variant='h2'
            >
              <a href='/properties'>{i18n.t('Properties')}</a>
              {` > ${property && property.Property ? property.Property : ''}`}
            </Typography>
          </HeaderTopBar>
          <Grid
            sx={{
              ...memberHeaderStyles.rowSub(theme),
              ...memberHeaderStyles.bottomBar(theme)
            }}
            item
          >
            <Grid container>
              <Box
                sx={memberHeaderStyles.toggleContainer(theme)}
                >
                <Tooltip
                  aria-label={`Add new ${i18n.t('unit')}`}
                  title={`Add new ${i18n.t('unit')}`}
                >
                  <Button
                    sx={memberHeaderStyles.navButton(theme)}
                    onClick={() => setOpenAddUnitDialog(true)}
                  >
                    <i className={'icon-add'} />
                    <div>{i18n.t('Unit')}</div>
                  </Button>
                </Tooltip>
              </Box>
              <Box sx={memberHeaderStyles.grow(theme)} />
            </Grid>
          </Grid>
        </Grid>
      </Toolbar>
      <AddUnit
        open={openAddUnitDialog}
        setOpen={setOpenAddUnitDialog}
        triggerAction={handleAddUnit}

      />
    </AppBar>
  );
};

export default PropertyHeader;
